import React from "react"
import _ from "lodash"

type IAtRest = {
  rowData: {}
  namedItems: {}
}

const UsersAtRest = (props: IAtRest) => {
  const type = _.get(props, "rowData.users.type")
  const users = type === "user" ? _.get(props, "namedItems.users") : _.get(props, "namedItems.usergroups")
  const selectedUsers = _.get(props, "rowData.users.ids")

  let prefix = type === "user" ? "Users:" : "User Groups:"
  if(!selectedUsers.length) {
    return <span></span>
  } else if(selectedUsers.length === 1) {
    let code = ""
    if(type === "user") {
      prefix = "User:"
      code = _.get(_.find(users, (u) => u.userid === selectedUsers[0]), "name")
    } else {
      prefix = "User Group:"
      code = _.get(_.find(users, (u) => u.usergroupid === selectedUsers[0]), "code")
    }
    return <span>{`${prefix} ${code}`}</span>
  } else return <span>{`${prefix} Detailed`}</span>
}

export default UsersAtRest
